import React, { useRef, useEffect, useState } from 'react'
import { VideoStyles } from 'styles/style';
import { watermarkImageWithText } from 'helpers/Watermark';
import { useAuth } from 'hooks/auth';
import { api } from 'supabase/database/api.ts';

const VideoContent = ({
    vid_key,
 }) => {
    const videoRef = useRef(null);
	const { user } = useAuth();
	const [userId, setUserId] = useState("");

    useEffect(() => {
    	// Disable fullscreen button (and potentially other controls)
    	const videoElement = videoRef.current;
    	if (videoElement) {
    		videoElement.controlsList = "nodownload"; // Remove download button
    		// Attempt to remove the fullscreen button (may not work in all browsers)
    		const fullscreenButton = videoElement.querySelector(
    			".vjs-fullscreen-control"
    		);
    		if (fullscreenButton) {
    			fullscreenButton.style.display = "none";
    		}
    		// Detect and prevent fullscreen attempts via API
    		videoElement.addEventListener("webkitendfullscreen", () => {
    			if (document.webkitIsFullScreen) {
    				document.webkitExitFullscreen();
    			}
    		});
    	}
    }, []);
	
	useEffect(() => {
    	async function fetchUserInfo() {
		  if (!user || !user.email) return;
    	  const data = await api.authQueries.getUserInfo({ email: user.email })
    	  setUserId(data[0].registration_number)
    	};

		fetchUserInfo();
	}, [user]);

	useEffect(() => {
		const setWatermarkWidth = () => {
			try {
				// Swarmify's watermark plugin puts "vjs-watermark" on the overlay
				// wrapper div; the actual <img> is a child inside it. The wrapper
				// only sizes to fit its content by default, so stretch both it
				// and the image to cover the full player.
				const watermarkImg = document.querySelector(".vjs-watermark img");
				if (watermarkImg && userId !== "") {
					const watermarkWrapper = watermarkImg.closest(".vjs-watermark");
					if (watermarkWrapper) {
						watermarkWrapper.setAttribute(
							"style",
							"position: absolute !important; inset: 0 !important; transform: none !important; width: 100% !important; height: 100% !important; max-width: none !important; pointer-events: none;"
						);
					}
					watermarkImg.setAttribute(
						"src",
						watermarkImageWithText(userId)
					);
					watermarkImg.setAttribute(
						"style",
						"width: 100% !important; height: 100% !important; object-fit: cover; opacity: 0.15; pointer-events: none;"
					);
				}
			} catch (error) {
				// Silently handle watermark errors
			}
		};

		if (userId) {
			const timeoutId = setTimeout(setWatermarkWidth, 2000);
			return () => clearTimeout(timeoutId);
		}
	}, [userId])

	// Swarmify's video.js build creates its "Swarm" logger fresh on every load
	// with the level hardcoded to "debug", so there's no reachable instance to
	// flip back via window.videojs.log — it's filtered at the console in public/index.html.

    return (
        <VideoStyles.VideoContainer key={vid_key}>
	    	<smartvideo
	    		ref={videoRef} // Add this ref
	    		className="swarm-fluid"
	    		controls
	    		playsInline
	    		webkit-playsinline="true"
	    		src={
	    			vid_key?.length === 11
	    				? `https://www.youtube.com/embed/${vid_key}?playsinline=1`
	    				: `swarmify://${vid_key}`
	    		}
	    	></smartvideo>
        </VideoStyles.VideoContainer>
    )
}

export default VideoContent